import React, { ReactElement, Component, useEffect, useContext, useState, useMemo, Fragment, useCallback } from "react";
import { FormattedMessage, injectIntl } from 'react-intl';
import './workload-list.less';
import { ItemsContext, item } from "../../contexts/items";
import { CardSelectableContext } from "../../contexts/card-selectable";
import { SearchTitleContext } from "../../contexts/search-title";
import { http_get, http_request, destroy_worker, response_type } from "../../worker/http-func";
import { IsInTabsContext } from "../../contexts/is-in-tabs";
import TableList from "../../components/table-list/table-list";
import { TableDescContext } from "../../contexts/table-desc";
import { IsFreshContext } from '../../contexts/is_fresh';
import { ClusterSelectedContext } from "../../contexts/cluster-selected";
import { WorkSpaceSelectedContext } from "../../contexts/workspace-selected";
import { WorkloadContext, workload_type_item } from "../../contexts/workloads";
import { workspaces_type_item, WorkspaceContext } from "../../contexts/workspaces";
import { NamespaceContext, namespaces_type_item } from "../../contexts/namespaces";
import { NameSpaceSelectedContext } from "../../contexts/namespace-selected";
import { TypeNameContext } from "../../contexts/type_name";
import { ClustersForPageContext } from "../../contexts/clusters-for-page";
import { IUserInfoType, UserInfoContext } from "../../contexts/user-info";
import { clusters_for_page_type } from "../../contexts/clusters-for-page";
import { ClusterContext, clusters_type_item } from "../../contexts/clusters";
import { DatacenternameContext } from "../../contexts/datacenter-name";
import { RefreshWorkloadsContext, refresh_workloads_type } from "../../contexts/refresh-worloads";
import { SyncOutlined, MoreOutlined, RightOutlined, DownOutlined, LoadingOutlined } from "@ant-design/icons";
import { Button, Card, Table, Tag, Dropdown, Menu } from "antd";
import { Link } from "react-router-dom";
import { WorkloadSelectedContext } from "../../contexts/workload-selected";
import { loading_type } from "../../components/table-list/table-list";
import { PodSelectedContext } from "../../contexts/pod_seleted";
import { PodsContext, pods_type_item } from "../../contexts/pods";
import { UnitContext } from "../../contexts/unit";
import { prevent } from "../applications/applications";
import { TableListModalTypeContext, table_list_modal_type } from "../../contexts/table_list_modal";
import { ItemSelectedContext } from "../../contexts/item-selected";
import { useDeepCompareMemo } from 'use-deep-compare';
import { get_time } from "../../shared-functions";

export interface containers_type_item {
    name: string;
    image: string;
    cpu: {
        limit: string;
        request: string;
    };
    memory: {
        limit: string;
        request: string;
    }
    restart: string;
    podName: string;
}

const WorkloadInfoContainers: React.FC = (props: any): ReactElement<any, string | (new (props: any) => Component<any, any, any>)> | null => {
    const pod_selected: item | undefined = useContext(PodSelectedContext)[0],
        // [table_list_modal, set_table_list_modal]: [table_list_modal_type, React.Dispatch<React.SetStateAction<table_list_modal_type>>] = useContext(
        //     TableListModalTypeContext
        // ),
        cluster_selected: item | undefined = useContext(ClusterSelectedContext)[0],
        namespace_selected: item | undefined = useContext(NameSpaceSelectedContext)[0],
        user_info: IUserInfoType = useContext(UserInfoContext)[0],
        datacenter_name: string | undefined = useContext(DatacenternameContext)[0],
        // set_item_selected: React.Dispatch<React.SetStateAction<item>> = useContext(ItemSelectedContext)[1],
        [loading, set_loading]: [loading_type, React.Dispatch<React.SetStateAction<loading_type>>] = useState<loading_type>({ container: false } as loading_type),
        [containers, set_containers]: [containers_type_item[] | undefined, React.Dispatch<React.SetStateAction<containers_type_item[] | undefined>>] = useState<containers_type_item[] | undefined>();
        // [container_table, set_container_table]: [JSX.Element, React.Dispatch<React.SetStateAction<JSX.Element>>] = useState<JSX.Element>(<p></p>);
    const containers_column: any = [
        {
            title: <FormattedMessage id="name" />,
            key: 'name',
            dataIndex: 'name',
            render: (name: any) => {
                return {
                    children: <div>{name}</div>,
                    props: {
                        "data-title": "Name: ",
                    },
                }
            }
        },
        {
            title: 'Image',
            key: 'image',
            dataIndex: 'image',
            render: (image: any) => {
                return {
                    children: <div>{image}</div>,
                    props: {
                        "data-title": "Image: ",
                    },
                }
            }
        },
        {
            title: 'CPU(request/limit)',
            key: 'cpu',
            dataIndex: 'cpu',
            render: (cpu: any) => {
                return {
                    children: <div>{cpu.requestCPU}/{cpu.limitCPU}</div>,
                    props: {
                        "data-title": "CPU(request/limit): ",
                    },
                }
            }
        },
        {
            title: 'Memory(request/limit)',
            key: 'memory',
            dataIndex: 'memory',
            render: (memory: any) => {
                return {
                    children: <div>{memory.requestMemory}/{memory.limitMemory}</div>,
                    props: {
                        "data-title": "Memory(request/limit): ",
                    },
                }
            }
        },
        {
            title: 'Restart',
            key: 'restart',
            dataIndex: 'restart',
            render: (restart: any) => {
                return {
                    children: <div>{restart}</div>,
                    props: {
                        "data-title": "Restart: ",
                    },
                }
            }
        },
        // {
        //     title: <FormattedMessage id="operation" />,
        //     key: 'operation',
        //     dataIndex: 'operation',
        //     render: (_text: any, record: pods_type_item) => {
        //         return {
        //             children: (
        //                 <div>
        //                     <Dropdown overlay={containers_menu} trigger={["click"]} placement="bottomCenter">
        //                         <Button
        //                             className="plain_button"
        //                             onClick={(event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
        //                                 prevent(event);
        //                                 set_item_selected(record as unknown as item);
        //                             }}>
        //                             <MoreOutlined />
        //                         </Button>
        //                     </Dropdown>
        //                 </div>
        //             ),
        //             props: {
        //                 "data-title": "Operation: ",
        //             },
        //         }
        //     }
        // },
    ];
    // const containers_menu: JSX.Element = !table_list_modal.visible ? (
    //     <Menu
    //         onMouseEnter={(e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    //             e.stopPropagation();
    //         }}>
    //         <Menu.Item>
    //             <div
    //                 className="font-9 text-center p-6"
    //                 onClick={(e: any) => {
    //                     e.stopPropagation();
    //                     set_table_list_modal((currentState) => ({
    //                         ...currentState,
    //                         visible: true,
    //                         is_logs: true,
    //                     }));
    //                 }}
    //             >
    //                 <FormattedMessage id="log" />
    //             </div>
    //         </Menu.Item>
    //     </Menu>
    // ) : (<Fragment></Fragment>);

    useEffect(() => {
        (async () => {
            const cluster_selected_name: string | undefined = cluster_selected?.name,
                namespace_selected_name: string | undefined = namespace_selected?.name,
                pod_selected_name: string | undefined = pod_selected?.name;
            if (cluster_selected_name && namespace_selected_name && pod_selected_name && datacenter_name) {
                // set_containers(undefined);
                const containsers_list: any = [];
                const pod_res: any = await http_request('pod_item', props, undefined, `/v1/datacenter/${datacenter_name}/cluster/${cluster_selected_name}/namespace/${namespace_selected_name}/pod/${pod_selected_name}`, 0, user_info.role, undefined, datacenter_name, cluster_selected_name);
                if (pod_res && pod_res?.Content) {
                    set_loading({ container: false });
                    pod_res.Content.spec.containers.forEach((item: any, index: number) => {
                        containsers_list.push({
                            name: item.name,
                            image: item.image,
                            cpu: {
                                limitCPU: item.resources.limits.cpu,
                                requestCPU: item.resources.requests.cpu
                            },
                            memory: {
                                limitMemory: item.resources.limits.memory,
                                requestMemory: item.resources.requests.memory
                            },
                            restart: pod_res.Content.status.containerStatuses[pod_res.Content.status.containerStatuses?.findIndex((container_status_item: any) => container_status_item.name === item.name)]?.restartCount,
                            podName: pod_res.Content.metadata.name
                        })
                    });
                    set_containers(containsers_list);
                }
            }
        })()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pod_selected?.name, namespace_selected?.name, cluster_selected?.name, user_info.role, datacenter_name, loading?.container])

    return (
        <Card className="pod_table">
            <div>
                <span className="px-20 table_title">Containers:</span>
                <Button
                    className="ml-10"
                    type="text"
                    onClick={() => {
                        set_loading({ container: true });
                    }}>
                    {
                        loading.container ? <LoadingOutlined spin /> : <SyncOutlined />
                    }
                </Button>
            </div>
            <Table
                className="third-table-header"
                size="small"
                columns={containers_column}
                dataSource={containers || []}
                rowKey={(container: containers_type_item) => container.name}
                pagination={{
                    pageSize: 6,
                    hideOnSinglePage: true,
                    showSizeChanger: false,
                }}
            ></Table>
        </Card>
    )
};

export const WorkloadInfoPod: React.FC = injectIntl((props: any): ReactElement<any, string | (new (props: any) => Component<any, any, any>)> | null => {
    const workload_seleted: item = useContext(WorkloadSelectedContext)[0],
        cluster_selected: item | undefined = useContext(ClusterSelectedContext)[0],
        namespace_selected: item | undefined = useContext(NameSpaceSelectedContext)[0],
        user_info: IUserInfoType = useContext(UserInfoContext)[0],
        datacenter_name: string | undefined = useContext(DatacenternameContext)[0],
        set_pod_selected: React.Dispatch<React.SetStateAction<item | undefined>> = useContext(PodSelectedContext)[1],
        unit_provide: string = useContext(UnitContext)[0],
        [pods, set_pods]: [pods_type_item[] | undefined, React.Dispatch<React.SetStateAction<pods_type_item[] | undefined>>] = useContext(PodsContext),
        [table_list_modal, set_table_list_modal]: [table_list_modal_type, React.Dispatch<React.SetStateAction<table_list_modal_type>>] = useContext(
            TableListModalTypeContext
        ),
        [item_selected, set_item_selected]: [item, React.Dispatch<React.SetStateAction<item>>] = useContext(ItemSelectedContext),
        refresh_workloads: refresh_workloads_type | undefined = useContext(RefreshWorkloadsContext)[0],
        [pod_expanded_keys, set_pod_expanded_keys]: [string[], React.Dispatch<React.SetStateAction<string[]>>] = useState<string[]>([]),
        { formatMessage }: { formatMessage: any } = useDeepCompareMemo(() => props.intl, [props.intl]),

        pod_delete = useCallback(() => {
            set_table_list_modal((currentState) => ({
                ...currentState,
                visible: true,
                modal_title: `${formatMessage({ id: "delete" })} ${item_selected.name}`,
                modal_message: (
                    <p>
                        <FormattedMessage id="delete_desc" />
                    </p>
                ) /*你确定要删除吗?*/,
                modal_ok_button: false,
                is_delete_pod: true,
            }));
        }, [item_selected.name, set_table_list_modal, formatMessage]);

    const workload_info_containers = () => {
        return <WorkloadInfoContainers />
    };
    const pods_column: any = [
        {
            title: <FormattedMessage id="status" />,
            key: 'status',
            dataIndex: 'status',
            render: (status: any) => {
                return {
                    children:
                        status?.toLocaleLowerCase() === "running" ? (
                            <Tag color="#2bc41ab5">
                                Running
                            </Tag>
                        ) : (
                                <Tag color="lightgray">
                                    {status}
                                </Tag>
                            ),
                    props: {
                        "data-title": "Status: ",
                    },
                }
            }
        },
        {
            title: <FormattedMessage id="name" />,
            key: 'name',
            dataIndex: 'name',
            render: (name: any) => {
                return {
                    children: <div>{name}</div>,
                    props: {
                        "data-title": "Name: ",
                    },
                }
            }
        },
        {
            title: <FormattedMessage id="created_at" />,
            key: 'creationTimestamp',
            dataIndex: 'creationTimestamp',
            render: (time: any) => {
                return {
                    children: <div>{get_time(time)}</div>,
                    props: {
                        "data-title": "Create At: ",
                    },
                }
            }
        },
        {
            title: <FormattedMessage id="node" />,
            key: 'node',
            dataIndex: 'node',
            render: (node: any) => {
                return {
                    children: <div>{node}</div>,
                    props: {
                        "data-title": "Node: ",
                    },
                }
            }
        },
        {
            title: <FormattedMessage id="operation" />,
            key: 'operation',
            dataIndex: 'operation',
            render: (_text: any, record: pods_type_item) => {
                return {
                    children: (
                        <div>
                            <Dropdown overlay={pods_menu} trigger={["click"]} placement="bottomCenter">
                                <Button
                                    className="plain_button"
                                    onClick={(event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
                                        prevent(event);
                                        set_item_selected(record as unknown as item);
                                    }}>
                                    <MoreOutlined />
                                </Button>
                            </Dropdown>
                        </div>
                    ),
                    props: {
                        "data-title": "Operation: ",
                    },
                }
            }
        },
    ];
    const pods_menu: JSX.Element = !table_list_modal.visible ? (
        <Menu
            onMouseEnter={(e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
                e.stopPropagation();
            }}>
            <Menu.Item>
                <Link
                    className="font-9 text-center p-6"
                    onClick={(e: any) => {
                        e.stopPropagation();
                        // set_workspace_selected(item_selected);
                    }}
                    to="/monitor"
                >
                    <FormattedMessage id="monitor" />
                </Link>
            </Menu.Item>
            <Menu.Item>
                <div
                    className="font-9 text-center p-6"
                    onClick={(e: any) => {
                        e.stopPropagation();
                        pod_delete();
                        set_table_list_modal((currentState) => ({
                            ...currentState,
                            visible: true,
                            modal_title: formatMessage({ id: "view_yaml" }),
                            is_view_yaml: true,
                            origin: 'pod',
                        }));
                    }}
                >
                    <FormattedMessage id="view_in_yaml" />
                </div>
            </Menu.Item>
            <Menu.Item>
                <div
                    className="font-9 text-center p-6"
                    onClick={(e: any) => {
                        e.stopPropagation();
                        pod_delete();
                    }}
                >
                    <FormattedMessage id="delete" />
                </div>
            </Menu.Item>
        </Menu>
    ) : (<Fragment></Fragment>);

    useEffect((): void => {
        set_pod_expanded_keys([""]);
    }, [unit_provide, workload_seleted]);

    useEffect(() => {
        (async () => {
            const podNamesList: string[] = [];
            if (workload_seleted?.podNames) {
                workload_seleted?.podNames.map((item: string) => {
                    return podNamesList.push(item)
                 })
            }
            if (workload_seleted?.unhealthyPodNames) {
                workload_seleted?.unhealthyPodNames.map((item: string) => {
                    return podNamesList.push(item)
                 })
            }
            if (podNamesList.length > 0) {
                const cluster_selected_name: string | undefined = cluster_selected?.name,
                    namespace_selected_name: string | undefined = namespace_selected?.name;
                if (cluster_selected_name && namespace_selected_name && datacenter_name) {
                    const pod_list: any = [];
                    const get_pod = async (pod_name: string): Promise<object | undefined> => {
                        const content: any = ((await http_request('pod_item', props, undefined, `/v1/datacenter/${datacenter_name}/cluster/${cluster_selected_name}/namespace/${namespace_selected_name}/pod/${pod_name}`, 0, user_info.role, undefined, datacenter_name, cluster_selected_name)) as unknown as any)?.Content;
                        content && pod_list.push({
                            uid: content.metadata.uid,
                            status: content.status.phase,
                            name: content.metadata.name,
                            creationTimestamp: content.metadata.creationTimestamp,
                            node: content.spec.nodeName,
                            containers: content.spec.containers,
                            containerStatuses: content.status.containerStatuses
                        });
                        return content
                    };
                    for (let i = 0; i < podNamesList.length; i++) {
                        await get_pod(podNamesList[i])
                    }
                    for (let i = 0; i < pod_list?.length; i++) {
                        pod_list[i]?.containers?.forEach((item: any, index: number) => {
                            item.restart = pod_list && pod_list[i]?.containerStatuses && pod_list[i]?.containerStatuses[index]?.restartCount
                        })
                    }
                    pod_list && set_pods(pod_list);
                }
            } else {
                set_pods([])
            };
        })()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [workload_seleted?.name, workload_seleted?.podNames, workload_seleted?.unhealthyPodNames, set_pods, namespace_selected?.name, cluster_selected?.name, user_info.role, datacenter_name, refresh_workloads?.delete_pod])

    return (
        <Card className="pod_table">
            <div>
                <span className="px-20 line-height-32 table_title">Pods:</span>
            </div>
            <Table
                className="pod_table second-table-header"
                size="small"
                columns={pods_column}
                dataSource={(pods && pods.filter((item: pods_type_item) => (item?.name !== refresh_workloads?.delete_pod))) || []}
                pagination={{
                    pageSize: 6,
                    hideOnSinglePage: true,
                    showSizeChanger: false,
                }}
                expandedRowRender={workload_info_containers}
                expandRowByClick
                onExpand={(expanded, record) => {
                    if (!expanded) set_pod_expanded_keys([""]);
                    else set_pod_expanded_keys([record.name]);
                }}
                expandIcon={({ expanded }) => (expanded ? <DownOutlined /> : <RightOutlined />)}
                expandedRowKeys={pod_expanded_keys}
                rowKey={(pod: pods_type_item) => pod.name}
                onRow={(record, _rowIndex) => {
                    return {
                        onClick: (_event) => {
                            set_pod_selected(record as unknown as item);
                        },
                    };
                }}
                showSorterTooltip={false}
            ></Table>
        </Card>
    )
});

const WorkloadList: React.FC = (props: any): ReactElement<any, string | (new (props: any) => Component<any, any, any>)> | null => {
    const [workloads, set_workloads]: [workload_type_item[] | undefined, React.Dispatch<React.SetStateAction<workload_type_item[] | undefined>>] = useContext(WorkloadContext),
        user_info: IUserInfoType = useContext(UserInfoContext)[0],
        set_clusters: React.Dispatch<React.SetStateAction<clusters_type_item[]>> = useContext(ClusterContext)[1],
        set_workspaces: React.Dispatch<React.SetStateAction<workspaces_type_item[] | undefined>> = useContext(WorkspaceContext)[1],
        set_namespaces: React.Dispatch<React.SetStateAction<namespaces_type_item[] | undefined>> = useContext(NamespaceContext)[1],
        set_items: React.Dispatch<React.SetStateAction<item[]>> = useContext(ItemsContext)[1],
        set_card_selectable: React.Dispatch<React.SetStateAction<boolean>> = useContext(CardSelectableContext)[1],
        set_search_title: React.Dispatch<React.SetStateAction<string>> = useContext(SearchTitleContext)[1],
        set_is_in_tabs: React.Dispatch<React.SetStateAction<boolean>> = useContext(IsInTabsContext)[1],
        set_table_desc: React.Dispatch<React.SetStateAction<string[]>> = useContext(TableDescContext)[1],
        is_fresh: boolean = useContext(IsFreshContext)[0],
        cluster_selected: item | undefined = useContext(ClusterSelectedContext)[0],
        workspace_selected: item | undefined = useContext(WorkSpaceSelectedContext)[0],
        namespace_selected: item | undefined = useContext(NameSpaceSelectedContext)[0],
        datacenter_name: string | undefined = useContext(DatacenternameContext)[0],
        clusters_for_page: clusters_for_page_type | undefined = useContext(ClustersForPageContext)[0],
        refresh_workloads: refresh_workloads_type | undefined = useContext(RefreshWorkloadsContext)[0],
        [type_name, set_type_name]: [string | undefined, React.Dispatch<React.SetStateAction<string | undefined>>] = useContext(TypeNameContext);

    useEffect((): void => {
        if (type_name) {
            const get_length = (type_name_new: string) =>
                ((clusters_for_page || {}) as { [key: string]: clusters_type_item[] | undefined })[`clusters_for_${type_name_new}_namespaces_page`]?.length;
            if (!get_length(type_name)) {
                const type_name_new: string = type_name === 'dedicate' ? 'shared' : 'dedicate';
                get_length(type_name_new) !== undefined && get_length(type_name_new) && set_type_name(type_name_new);
            }
        } else {
            sessionStorage.getItem('sidebarKey')?.includes('shared') ? set_type_name('shared') : set_type_name('dedicate')
        }
    }, [props, type_name, set_type_name, clusters_for_page]);

    useEffect(() => () => { destroy_worker() }, []);
    const { formatMessage } = useMemo(() => props.intl, [props]);

    useEffect((): void => {
        user_info.role !== '' && datacenter_name && http_get('workloads_page', ['clusters', set_clusters], user_info.role, `${user_info.subscription_id}&type=${type_name}`, datacenter_name, '');
    }, [set_clusters, user_info.role, user_info.subscription_id, type_name, datacenter_name]);

    useEffect((): void => {
        (async () => {
            if (cluster_selected?.name && datacenter_name) {
                const { name }: item = cluster_selected;
                if ((user_info.role === "workspaceOwner" && user_info.wkOwner_has_namespacedeveloper.includes(cluster_selected?.name)) || user_info.role === 'namespaceDeveloper') {
                    const workspacenames: { name: string, id: string }[] = (await http_request('workspacenames', props, undefined, `/v1/datacenter/${datacenter_name}/cluster/${cluster_selected.name}/workspacenames`, 0, user_info.role, `${user_info.subscription_id}&type=${type_name}`, datacenter_name, cluster_selected.name || '', undefined, undefined, undefined, undefined, true) as response_type).items as { name: string, id: string }[];
                    workspacenames && set_workspaces(workspacenames.map(({ name, id }) => { return { metadata: { name: id, labels: { name } } } as workspaces_type_item }));
                } else {
                    name && user_info.role !== '' && http_request('workspaces', props, set_workspaces, `/v1/datacenter/${datacenter_name}/cluster/${cluster_selected.name}/workspaces`, 0, user_info.role, `${user_info.subscription_id}&type=${type_name}`, datacenter_name, cluster_selected.name || '', undefined, undefined, undefined, undefined, true);

                }
            }
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [cluster_selected?.name, set_workspaces, user_info.role, user_info.subscription_id, user_info.wkOwner_has_namespacedeveloper]);

    useEffect((): void => {
        (async (): Promise<void> => {
            if (user_info.role !== '' && cluster_selected?.name && workspace_selected?.name && datacenter_name) {
                await http_request('namespaces', props, set_namespaces, `/v1/datacenter/${datacenter_name}/cluster/${cluster_selected?.name}/workspace/${workspace_selected.name}/namespaces`, 0, user_info.role,
                    `${user_info.subscription_id}&type=${type_name}`, datacenter_name, cluster_selected?.name, undefined, undefined, undefined, undefined, true);
            };
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [set_workloads, is_fresh, user_info.role, user_info.subscription_id, cluster_selected?.name, workspace_selected?.name, set_namespaces]);

    useEffect((): void => {
        const cluster_selected_name: string | undefined = cluster_selected?.name,
            namespace_selected_name: string | undefined = namespace_selected?.name;
        if (cluster_selected_name && namespace_selected_name && datacenter_name) {
            http_request('workloads', props, set_workloads,
                `/v1/datacenter/${datacenter_name}/cluster/${cluster_selected_name}/namespace/${namespace_selected_name}/workload`,
                0, user_info.role, `${user_info.subscription_id}&type=${type_name}`, datacenter_name, cluster_selected_name);
        } else {
            set_workloads([])
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [namespace_selected?.name, cluster_selected?.name, user_info.role, set_workloads, user_info.subscription_id, refresh_workloads]);

    useEffect((): void => {
        set_is_in_tabs(false);
    }, [set_is_in_tabs]);

    useEffect((): void => {
        set_table_desc([`${formatMessage({ id: 'workloads' })}`, `${formatMessage({ id: 'workloads_desc' })}`]);
    }, [set_table_desc, formatMessage]);

    useEffect((): void => {
        workloads && workloads.sort((a: item, b: item) => {
            return (a?.name && b?.name && a?.name.localeCompare(b?.name.toLocaleLowerCase() || "")) || 0;
        })
        set_items(workloads as unknown as item[]);
    }, [workloads, set_items]);

    useEffect((): void => {
        set_card_selectable(false);
    }, [set_card_selectable]);

    useEffect(() => {
        set_search_title('node');
    }, [set_search_title]);

    return (
        <div className="no_pointer">
            <TableList />
        </div>
    )
}

export default injectIntl(WorkloadList);